import router from '@R';
import { captureException } from '@sentry/browser';

/**
 * Adds most common and all headers in dropdown.
 * @param {Function} gettext - Handles translations.
 * @param {Node} container - phone input wrapper element.
 * @param {Object} options - options for classes and keys.
 */
export const addHeaders = (gettext, container, { target }) => {
    let targetEl = container.querySelector(target);
    let preferredListItems = targetEl.querySelectorAll('.preferred');
    let hasPreferred = preferredListItems && preferredListItems.length > 0;
    if (hasPreferred) {
        let headerListItem = document.createElement('div');
        let firstPreferred = Array.from(preferredListItems)[0];
        let divider = targetEl.querySelector('.divider');

        // Initialise Most Common header
        headerListItem.classList.add('header');
        headerListItem.classList.add('header--preferred');
        headerListItem.textContent = gettext('Most Common');
        firstPreferred.insertAdjacentElement('beforebegin', headerListItem);

        // Initialise All header
        let headerListItemClone = headerListItem.cloneNode();
        headerListItemClone.classList.remove('header--preferred');
        headerListItemClone.classList.add('header--all');
        headerListItemClone.textContent = gettext('All');
        divider.insertAdjacentElement('afterend', headerListItemClone);
    }
};

/**
 * Inserts any number of items at the given index.
 * @param {Array} arr - Original array.
 * @param {Number} index - Index to insert the items.
 * @param {Any} newItem - Item to be added to the array.
 * @return {Array} - Returns a new array with items inserted.
 */
export const insert = (arr, index, newItem) => [
    ...arr.slice(0, index),
    newItem,
    ...arr.slice(index)
];

/**
 * Retry an asynchronous function a set
 * number of times every second.
 * @param {Function} fn Callback to retry
 * @param {Number} retries Number of retries
 * @param {Error} err The error on failure (will flow down chain)
 */
export async function retry(fn, retries = 3, err = null) {
    let timeout;

    if (!retries) {
        clearTimeout(timeout);
        return Promise.reject(err);
    }

    try {
        const promise = await fn();
        clearTimeout(timeout);
        return promise;
    } catch (topError) {
        return new Promise(async (resolve, reject) => {
            timeout = setTimeout(async () => {
                try {
                    await retry(fn, (retries - 1), topError);
                    resolve(true);
                } catch (bottomError) {
                    reject(err)
                }
            }, 1000);
        });
    }
}

/**
 * Handle the catch of any dynamic imports that fail
 * @param {Error} err Promise related error
 */
export function catchImport(err) {
    const storedCount = parseInt(localStorage.getItem('reload-count'), 10);
    let count = 0;

    if (storedCount) {
        count = storedCount;
    }

    count += 1;

    localStorage.setItem('reload-count', count);

    if (count < 3) {
        // If no error message present then update
        // to show that an async import has failed.
        if (!err.message) {
            err.message = 'Asynchronous import has failed.';
        }
        // Capture the exception with Sentry
        captureException(err);
        // Reload the page
        window.location.reload(true);
        return;
    }
    router.replace({ name: 'fatal-error' });
}



// WEBPACK FOOTER //
// ./resources/assets/js/helpers/utils.js